function JsonMapper(responseRepository) {

	/**
	 * places @value on a @source, in the spot indicated by @valueStringArray.
	 * @mappedValueStarIndices is used for conversion callbacks and @isDefault determines if the value
	 * is to be placed only if no current value exists.
	 */
	function mapValues(source, valueStringArray, value, mappedValueStarIndices, isDefault) {
		var lastKey = valueStringArray.pop();
		for (var i = 0 ; i < valueStringArray.length; i++) {
			if ( ! source ) return null ;

			var key = valueStringArray[i], nextKey = valueStringArray[i+1] ;

			if ( key === '*') {
				for (var j = 0 ; j < source.length ; j++ ) {
					var vsa = valueStringArray.slice(i+1, valueStringArray.length) ;
					vsa.push(lastKey);
					var startIndices = mappedValueStarIndices ? mappedValueStarIndices: [];
					mapValues(source[j], vsa , value, startIndices.concat([j]),  isDefault) ;
				}
			} else if (key.indexOf('*[') == 0 && key.indexOf(']') == (key.length - 1)) {
				var propetyName = key.substring(2,key.length - 1);
				for (var j = 0 ; j < source.length ; j++ ) {
					var vsa = valueStringArray.slice(i+1, valueStringArray.length) ;
					vsa.push(lastKey);
					var startIndices = mappedValueStarIndices ? mappedValueStarIndices: [];
					//get propety value and append to startIndices like this [name=value]
					var propetyVal = source[j][propetyName];
					var indiceValue = '['+propetyName+'='+propetyVal+']';
					mapValues(source[j], vsa , value, startIndices.concat([j + indiceValue]),  isDefault) ;
				}
			} else if ( source[key] === undefined ) {
				createChildProperty(source, key, nextKey);
			}

			source = source[key] ;
		}

		if ( ! source ) {
			return ;
		}

		if ( ! (isDefault && ( source[lastKey] !== null && source[lastKey] !== undefined))) {
			var val = isFunction(value) ? value(source[lastKey], mappedValueStarIndices) : value;
			source[lastKey] = val;
		}
	}

	function createChildProperty(target, key, nextKey) {
		if ( nextKey === '*' ) {
			target[key] = [];
		}
		else if ( Number.isNumeric(nextKey)){
			target[key] = [];
		}
		else {
			target[key] = {} ;
		}
	}


	function fetchValue(value, requestData) {
		if ( isFunction(value) )
			return value() ;

		if ( typeof(value) !== 'string')
			return value;

		if ( value.indexOf('=') === -1 )
			return value ;

		var valueStringArray = value.substring(1, value.length).split('.');
		var sourceIdentifier = valueStringArray[0];
		var source = getSource(sourceIdentifier, requestData);

		valueStringArray.shift() ; /** first element in the array is the source identifier */
		for (var i = 0 ; i < valueStringArray.length; i++) {
			if ( ! source ) return null ;
			source = source[valueStringArray[i]] ;
		}

		return source;
	}

	function getSource(source, requestData) {
		if ( source == '_input' )
			return requestData;

		source = source.substring(1, source.length); // remove _
		return responseRepository.getLastResponseFrom(source);
	}


	function transform(requestData, mapping) {
		var inflated = requestData ;
		for (var key in mapping) {
			value = mapping[key];
			mapValues(requestData, key.split('.'), function() {
				return fetchValue(value, requestData)
			} ) ;
		}

		return inflated;
	}

	function convert(requestData, mapping) {
		for (var key in mapping) {
			converterFn = mapping[key];
			mapValues(requestData, key.split('.'), converterFn) ;
		}

		return requestData;
	}

	function setDefaultValues(requestData, mapping) {
		for (var key in mapping) {
			value = mapping[key];
			mapValues(requestData, key.split('.'), value, null, true) ;
		}

		return requestData;
	}

	return {
		transform: transform,
		convert: convert,
		setDefault: setDefaultValues
	}
}
